import * as React from "react";
const SvgListUl = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#000000", width: 240, height: 240, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 6h2v2H4zm0 5h2v2H4zm0 5h2v2H4zm16-8V6H8.023v2H18.8zM8 11h12v2H8zm0 5h12v2H8z" }));
export default SvgListUl;
